import { useState } from "react";
import { api, API, TOKEN_KEY, errText } from "@/lib/api";

export const VaultLogin = ({ onIn }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await api.post(`${API}/auth/login`, { email, password });
      sessionStorage.setItem(TOKEN_KEY, data.token);
      onIn(data.email);
    } catch (x) {
      setErr(errText(x));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="v-login">
      <img src="/media/eye-black.webp" alt="" className="v-eye" />
      <h1>The Vault</h1>
      <p className="v-sub">Members of the house only.</p>
      <form onSubmit={submit} className="v-form" data-testid="vault-login-form">
        <input type="email" placeholder="Email" autoComplete="username" value={email}
          onChange={(e) => setEmail(e.target.value)} required data-testid="vault-email-input" />
        <input type="password" placeholder="Password" autoComplete="current-password" value={password}
          onChange={(e) => setPassword(e.target.value)} required data-testid="vault-password-input" />
        <button type="submit" disabled={busy} data-testid="vault-login-button">{busy ? "Opening…" : "Enter"}</button>
        <p className="v-err" role="alert" data-testid="vault-login-error">{err}</p>
      </form>
    </main>
  );
};
